import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { FlowOutputStep } from '../types/FlowOutputStep';
import { FlowOutputStepRun } from '../types/FlowOutputStepRun';
import { FlowRun } from '../types/FlowRun';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { RunFlowTask } from '../types/RunFlowTask';

export type GetFlowOutputStepRunsParams = IGetItemsParams;

export type GetFlowOutputStepRunsResult = IGetItemsResult & {
  readonly flowOutputStepRuns: FlowOutputStepRun[];
  readonly flowRuns: FlowRun[];
  readonly runFlowTasks: RunFlowTask[];
  readonly schedules: ISchedule[];
  readonly flowOutputSteps: FlowOutputStep[];
  // readonly publishedDataSources: UnifiedDataSource[];
};

export class GetFlowOutputStepRunsRequest extends Request<GetFlowOutputStepRunsParams, GetFlowOutputStepRunsResult> {
  constructor(params: GetFlowOutputStepRunsParams) {
    super('getFlowOutputStepRuns', params);
  }
}
